export class ConversationThreadRequestCoordinator {
  constructor() {
    this.active = null;
  }

  request(key, run) {
    if (this.active?.key === key) return this.active.promise;
    this.abort();

    const controller = new AbortController();
    const active = {
      key,
      controller,
      promise: null,
    };
    active.promise = Promise.resolve()
      .then(() => run(controller.signal))
      .finally(() => {
        if (this.active === active) this.active = null;
      });
    this.active = active;
    return active.promise;
  }

  abort() {
    if (!this.active) return;
    this.active.controller.abort();
    this.active = null;
  }
}
